<template>
<div>
	<v-list v-if="isMounted && $vuetify.breakpoint.mdAndUp" class="fixit-no__item-list" :style="'background: var(--v-secondary-base)'">
		<v-list-item
			:style="{
				color: useConstrastColors ? 'var(--v-primary-text-base)' : 'color: var(--v-secondary-base)',
				'border-bottom': '1px solid var(--v-primary-base)',
			}"
			id="menu-item-button"
			v-for="(item, index) in items"
			:key="index"
			@click="navigationAction(item)"
		>
			<v-list-item-title :style="useConstrastColors ? 'var(--v-primary-text-base)' : 'color: var(--v-primary-base)'">{{ item.Caption }}</v-list-item-title>
			<v-list-item-action>
				<v-icon size="20px" color="primary">fxt-chevron-right</v-icon>
			</v-list-item-action>
		</v-list-item>
		<choose-salon-dialog :disabled="headerProps.draftMode" :url="headerProps.fixitNoUrl" :sites="headerProps.sites" v-if="headerProps.items.filter((i) => i.Visible && i.Type == 2).length" @closeMenu="closeMenu"/>
	</v-list>
	
	<v-list v-else class="fixit-no__item-list" :style="'background: var(--v-secondary-base)'">
		<v-list-item
			:style="{
				color: useConstrastColors ? 'var(--v-primary-text-base)' : 'color: var(--v-secondary-base)',
				'border-bottom': '1px solid var(--v-primary-base)',
			}"
			v-for="(item, index) in dropdownItems"
			:key="index"
			id="menu-item-button"
			@click="navigationAction(item)"
		>
			<v-list-item-title :style="useConstrastColors ? 'var(--v-primary-text-base)' : 'color: var(--v-primary-base)'">{{ item.Caption }}</v-list-item-title>
			<v-list-item-action>
				<v-icon size="20px" color="primary">fxt-chevron-right</v-icon>
			</v-list-item-action>
		</v-list-item>

		<choose-salon-dialog @closeMenu="closeMenu()" class="mt-4" :disabled="isDraft" :url="$config.PORTAL_URL" :sites="bookingSites" v-if="headerProps.items.filter((i) => i.Visible && i.Type == 2).length" />
	</v-list>
</div>
</template>
<script>
import {ChooseSalonDialog} from './Common/CommonComponents';
import {Header } from '../models';

export default {
	components: {
		ChooseSalonDialog
	},
	props: {
		items: {
			type: Array,
			default: function () {
				return [];
			},
		},
		headerProps: {
			type: [Header, Object],
			default: function () {
				return new Header();
			},
		}
	},
	data: () => ({
		isMounted: false,
	}),
	mounted() {
		this.isMounted = true;
	},
	methods: {
		navigationAction(item) {
			this.$emit('navigationAction', item);
		},
		closeMenu(){
            this.$emit('closeMenu')

		}
	},
	computed: {
		salons() {
			return this.$store.getters['salon/getSalons']
		},
		useConstrastColors() {
			return this.headerProps.layout == 'chain' ? this.$store.getters['cmsConfigHomepage/primaryAndSecondaryAreEqual'] : false
		},
		dropdownItems() {
			return this.items.filter(item => item.Id != 7)
		},
		isDraft() {
			return this.$store.getters['cmsConfigHomepage/isDraftMode']
		},
		bookingSites() {
			if (!(this.$router.currentRoute.path.includes('nettbutikk') || window.location.host.includes('profil.'))) {
				let selectedSalon = this.$store.getters['cart/getSelectedSalon']
				if (selectedSalon) {
					return this.salons.filter(x => x.siteId === selectedSalon);
				} else {
					return this.salons
				}
			} else return this.salons
		}
	}
};
</script>